import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';

import { sanitizeRedirect } from '@/lib/urlUtils';

import { AUTH_DATA_QUERY_KEY, useAuthData } from './useApiKey';

interface Props {
    isSessionExpired: boolean;
}

export function useLogout({ isSessionExpired }: Props) {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { setAuthData } = useAuthData();

    return () => {
        setAuthData(null);
        localStorage.removeItem(AUTH_DATA_QUERY_KEY);
        queryClient.clear();

        // Only a forced (session-expiry) logout preserves the path; a manual logout lands on a clean /auth.
        const safeRedirect = isSessionExpired
            ? sanitizeRedirect(
                  window.location.pathname +
                      window.location.search +
                      window.location.hash,
              )
            : undefined;

        // Workaround to allow state to clear before navigating; remove this after refactoring useEffect in root route
        setTimeout(() => {
            navigate({
                to: '/auth',
                replace: true,
                state: { isSessionExpired },
                search: safeRedirect ? { redirect: safeRedirect } : {},
            });
        }, 1000);
    };
}
